<!-- Modal backdrop -->
<div
  class="fixed inset-0 z-60 bg-black/30"
  (click)="onCancelClicked()"
></div>

<!-- Modal container -->
<div class="fixed inset-0 top-18 z-65 flex items-start justify-center py-8 px-4 pointer-events-none">
  <div
    class="flex flex-row gap-6 max-w-4xl w-full h-full pointer-events-auto"
    (click)="$event.stopPropagation()"
  >
    <div 
      class="flex-1 flex flex-col bg-white dark:bg-gray-800 rounded-lg shadow-md max-h-[80vh] relative"
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-us-title"
      (click)="$event.stopPropagation()"
    >
        <!-- Header with title and close button -->
        <div
          class="p-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 rounded-t-lg flex items-center justify-between"
        >
          <span id="contact-us-title" class="text-blue-800 text-2xl font-semibold">{{ 'Contact Us' | transloco }}</span>
          
          <!-- Close button -->
          <button
            type="button"
            (click)="onCancelClicked()"
            class="text-gray-600 hover:text-gray-800 dark:text-gray-300 dark:hover:text-gray-100 transition-colors duration-200 p-1"
            [attr.aria-label]="'Close contact us modal' | transloco"
          >
            <ng-icon name="matCloseOutline" size="24"></ng-icon>
          </button>
        </div>

        <!-- Scrollable content area -->
        <div class="flex-1 overflow-y-auto p-6">
          <form (ngSubmit)="onSubmit()">
            <div class="space-y-6">
              <!-- Company Information Section -->
              <div>
                <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                  <span>{{ 'Company Information' | transloco }}</span>
                  <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
                </h3>
                
                <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 space-y-4">
                  <!-- Company Name -->
                  <div>
                    <h4 class="text-xl font-semibold text-blue-800 dark:text-blue-300 mb-2">
                      FLOWPOINT ENVIRONMENTAL SYSTEMS
                    </h4>
                  </div>

                  <!-- Contact Details -->
                  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <!-- Sales Phone -->
                    <div class="flex items-center gap-3">
                      <ng-icon name="matPhone" size="20" class="text-blue-600"></ng-icon>
                      <div>
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-100">{{ 'Sales Phone' | transloco }}</p>
                        <p class="text-gray-900 dark:text-white">
                          <a href="tel:+18776555585" class="hover:text-blue-600 transition-colors">
                            877.655.5585 ext. 1
                          </a>
                        </p>
                      </div>
                    </div>

                    <!-- Support Phone -->
                    <div class="flex items-center gap-3">
                      <ng-icon name="matPhone" size="20" class="text-blue-600"></ng-icon>
                      <div>
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-100">{{ 'Support Phone' | transloco }}</p>
                        <p class="text-gray-900 dark:text-white">
                          <a href="tel:+18776555585" class="hover:text-blue-600 transition-colors">
                            877.655.5585 ext. 2
                          </a>
                        </p>
                      </div>
                    </div>

                    <!-- Sales Email -->
                    <div class="flex items-center gap-3">
                      <ng-icon name="matEmail" size="20" class="text-blue-600"></ng-icon>
                      <div>
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-100">{{ 'Sales Email' | transloco }}</p>
                        <p class="text-gray-900 dark:text-white">
                          <a href="mailto:sales&#64;flowpointsystems.com" class="hover:text-blue-600 transition-colors">
                            sales&#64;flowpointsystems.com
                          </a>
                        </p>
                      </div>
                    </div>

                    <!-- Support Email -->
                    <div class="flex items-center gap-3">
                      <ng-icon name="matEmail" size="20" class="text-blue-600"></ng-icon>
                      <div>
                        <p class="text-sm font-medium text-gray-700 dark:text-gray-100">{{ 'Support Email' | transloco }}</p>
                        <p class="text-gray-900 dark:text-white">
                          <a href="mailto:support&#64;flowpointsystems.com" class="hover:text-blue-600 transition-colors">
                            support&#64;flowpointsystems.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Message Section -->
              <div>
                <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                  <span>{{ 'Send us a Message' | transloco }}</span>
                  <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
                </h3>

                <!-- Subject Field -->
                <div class="mb-4">
                  <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                    <label for="contact-subject" class="flex flex-row items-center">
                      <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Subject' | transloco }}
                    </label>
                  </div>
                  <input
                    id="contact-subject"
                    [(ngModel)]="contactForm.subject"
                    name="subject"
                    type="text"
                    required
                    class="w-full max-w-full shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition duration-200"
                    placeholder="{{ 'Enter the subject of your inquiry' | transloco }}"
                  />
                </div>

                <!-- Message Textarea -->
                <div class="mb-4">
                  <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                    <label for="contact-message" class="flex flex-row items-center">
                      <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Message' | transloco }}
                    </label>
                  </div>
                  <textarea
                    id="contact-message"
                    [(ngModel)]="contactForm.message"
                    name="message"
                    rows="8"
                    required
                    class="w-full max-w-full shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition duration-200 resize-none"
                    placeholder="{{ 'Please describe your inquiry, questions, or how we can help you...' | transloco }}"
                  ></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!-- Footer with buttons -->
        <div class="bg-gray-100 dark:bg-gray-800 flex flex-row items-center justify-center p-4 border-t rounded-b dark:border-gray-600 shadow-lg z-10 relative max-sm:rounded-none gap-4">
          <!-- Submit button -->
          <button
            type="button"
            (click)="onSubmit()"
            [disabled]="!contactForm.subject || !contactForm.message"
            class="flex-1 bg-blue-800 hover:bg-blue-900 disabled:bg-gray-300 disabled:cursor-not-allowed text-white transition-colors duration-200 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-sm px-5 py-2.5 text-center min-w-[120px] max-w-[200px]"
            [attr.aria-label]="'Send contact us message'"
          >
            {{ 'Send Message' | transloco }}
          </button>

          <!-- Cancel button -->
          <button
            type="button"
            (click)="onCancelClicked()"
            class="flex-1 bg-gray-500 border-gray-500 text-white hover:bg-gray-600 hover:text-white transition-colors duration-200 focus:ring-4 focus:outline-none focus:ring-gray-300 rounded-lg text-sm px-5 py-2.5 text-center min-w-[120px] max-w-[200px]"
            [attr.aria-label]="'Cancel contact us form'"
          >
            {{ 'Cancel' | transloco }}
          </button>
        </div>
      </div>
    </div>
  </div>


